import { Col, Radio, Row } from "antd";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { success, error } from "../../contants/snackbars";
import { colorScheme } from "../../contants/variables";
import {
  LoadingButton,
  PrimaryButton,
} from "../../custom_components/customButton";
import {
  addCarProduct,
  savedCarProduct,
  updateCarProduct,
} from "../../stores/api_calls/carlists";
import { MobileView, WebView } from "./Views";

const PreviewCar = (props) => {
  const { isEdit, form, selectedFiles } = props;
  const [view, setView] = useState(0);
  const [requestLoading, setRequestLoading] = useState(false);
  const [localImageUrls, setLocalImageUrls] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Slots hold uploaded S3 urls (or a local preview while uploading) —
    // never File objects — already in display order.
    setLocalImageUrls(selectedFiles.map((slot) => slot.url || slot.preview));
  }, [selectedFiles]);

  const onViewChange = (e) => {
    setView(e.target.value);
  };

  const onSubmit = () => {
    setRequestLoading(true);

    // Images were uploaded when selected; slot order is the display order,
    // and the API persists it as order_number from this array.
    const imagesIds = selectedFiles
      .filter((slot) => slot._id)
      .map((slot) => slot._id);

    const car = isEdit
      ? updateCarProduct(form, imagesIds)
      : addCarProduct(form, imagesIds);
    car
      .then((res) => {
        success(`Bike ${isEdit ? "updated" : "added"} Successfully`);
        setRequestLoading(false);
        navigate("../bikes/verified", { replace: true });
      })
      .catch((e) => {
        console.log(e);
        error(e?.response?.data?.server_response ?? "Something went wrong.");
        setRequestLoading(false);
      });
  };

  // const onSaved = () =>{
  //     const imagesIds = []

  //     selectedFiles.forEach((file,index)=>{
  //         const onUpload = uploadImage(file)

  //         onUpload.then((res)=>{
  //             console.log(res.data)
  //             if(res.data.success){
  //                 imagesIds.push(res.data.data._id)
  //             }

  //             if(imagesIds.length===selectedFiles.length){
  //                 // console.log('images' ,imagesIds.length , imagesIds)
  //                 const car = savedCarProduct(form , imagesIds)
  //                 car.then((res)=>{
  //                     console.log('create ad', res.data)
  //                 }).catch(e=>console.log(e))
  //             }
  //         }).catch(e=>console.log(e))
  //     })
  // }

  return (
    <div>
      <Row>
        <Col span={8}>
          <div className="preview-text-container">
            <p className="preview-header">
              Choose the device you want to preview
            </p>
            <Radio.Group onChange={onViewChange} value={view}>
              <Radio value={0}>Web Application</Radio>
              <Radio value={1}>Mobile Application</Radio>
            </Radio.Group>

            <p className="preview-note">
              If you are happy with the result kindly click button below.
            </p>

            <div className="button-container">
              {/* <PrimaryButton className="button" color={colorScheme.secondary} label="Save as Draft" onClick={onSaved}/> */}
              {requestLoading ? (
                <LoadingButton />
              ) : (
                <PrimaryButton
                  className="button"
                  color={colorScheme.primary}
                  label={isEdit ? "Post This Ad" : "Post This Ad"}
                  onClick={onSubmit}
                />
              )}
            </div>
          </div>
        </Col>

        <Col span={16}>
          <div className="preview-container">
            <p style={{ marginBottom: "10px" }}>
              Hover on the screen and scroll to view contents
            </p>
            {!view ? (
              <WebView form={form} localImageUrls={localImageUrls} />
            ) : (
              <MobileView form={form} localImageUrls={localImageUrls} />
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default PreviewCar;
